module.exports = __webpack_public_path__ + "img/certif-1.7e250d0a.png";